import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Page404 from '../../components/Page404';
import UserSubscriptionServiceList from './UserSubscriptionServiceList';

const SubscriptionRouter = () => {
  const { url } = useRouteMatch();

  return (
    <Switch>
      <Route
        exact
        path={`/SubscriptionServices/UserSubscriptionServices`}
        component={UserSubscriptionServiceList}
      />
      <Route component={Page404} />
    </Switch>
  );
};

export default SubscriptionRouter;
